import { render, staticRenderFns } from "./Advices.vue?vue&type=template&id=0d4c4128&scoped=true&"
import script from "./Advices.vue?vue&type=script&lang=js&"
export * from "./Advices.vue?vue&type=script&lang=js&"
import style0 from "./Advices.vue?vue&type=style&index=0&id=0d4c4128&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c4128",
  null
  
)

export default component.exports